module.exports = __webpack_public_path__ + "img/CARACTER-SWIFT-2.89ad3b0d.jpg";